// extracted by mini-css-extract-plugin
module.exports = {"playerScore":"Score_playerScore__2w7nT","scoreElement":"Score_scoreElement__CyRuA","tabloid":"Score_tabloid__3i9Hz"};